import { useIntl } from "react-intl";
import Header from "../../components/Header";
import Slider from "../../components/Slider";
import Breadcrumbs from "../../components/Breadcrumbs";
import Footer from "../../components/Footer";
import CookieAccept from "../../components/CookieAccept";
import SEO from "../../components/SEO";

export default function SectionLayout(props) {
  const intl = useIntl();

  let Miasto = props.miasto;
  let Podatek = props.podatek;

  return (
    <>
      {/* HEAD */}
      <SEO miasto={Miasto} podatek={Podatek} />

      {/* TOP */}

      <Header miasto={Miasto} />

      <Slider miasto={Miasto} podatek={Podatek} small typeHero="slider" />

      <Breadcrumbs miasto={Miasto} layout="light" />

      {/* SECTION */}

      {props.children}

      {/* BOTTOM */}

      <Footer miasto={Miasto} />
    </>
  );
}
